import { MRT_ColumnDef, MaterialReactTable, useMaterialReactTable } from 'material-react-table'
import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR'
import { AlertType, RetAPI, Transportadora, bgLineGridColorDark, bgLineGridColorLight, corBgGrid } from '../../Utils/Types'
import { useSelector } from 'react-redux'
import { selectUser } from '../Redux/userSlice'
import { ThemeProvider, createTheme } from '@mui/material'
import { useNavigate } from 'react-router-dom'
import { ModalExcluirDados } from '../Modal/ModalExcluirDados'
import { TransportadoraService } from '../../Pages/Transportadora/TransportadoraService'
import moment from 'moment'
import { Funcoes } from '../../Utils/Funcoes'
import { Tooltip } from 'react-tooltip'
import { FaTrashAlt } from 'react-icons/fa'
import { RiEdit2Fill } from 'react-icons/ri'

type Props = {
    transportadora: Transportadora[],
    handleUpdateTransportadoraList: () => void,
}

type VisibilityState = Record<string, boolean>

interface RowData {
    id: number,
    razao: string,
    nome_fantasia: string,
    endereco: string,
    bairro: string,
    numero: string,
    cep: string,
    id_cidade: number,
    complemento: string,
    ie_rg: string,
    observacao: string,
    tipo_pessoa: string,
    cnpj_cpf: string,
    ativo: string,
    uf: string,
    dt_cadastro: string,
    nome_cidade: string
}

type TipoMap = {
    [key: string]: string
}

export const GridTransportadora = React.memo(({ transportadora, handleUpdateTransportadoraList }: Props) => {

    const defaultJson = useMemo(() => {
        return (

            localStorage.getItem("@commerce/column_grid_transp")
                ? JSON.parse(localStorage.getItem("@commerce/column_grid_transp") || '')
                : {
                    acao: true,
                    razao: true,
                    nome_fantasia: true,
                    endereco: false,
                    bairro: false,
                    numero: false,
                    cep: false,
                    nome_cidade: true,
                    complemento: false,
                    ie_rg: false,
                    observacao: false,
                    tipo_pessoa: false,
                    cnpj_cpf: true,
                    ativo: false,
                    uf: true,
                    dt_cadastro: false,
                }
        )
    }, [])

    /*
    const xJson = localStorage.getItem("@commerce/column_grid_transp")

    let json: any = {
        acao: true,
        razao: true,
        nome_fantasia: true,
        endereco: false,
        bairro: false,
        numero: false,
        cep: false,
        nome_cidade: true,
        complemento: false,
        ie_rg: false,
        observacao: false,
        tipo_pessoa: false,
        cnpj_cpf: true,
        ativo: false,
        uf: true,
        dt_cadastro: false,
    }

    if (xJson) {
        json = JSON.parse(localStorage.getItem("@commerce/column_grid_transp") || '')
    }
    */

    /*
    useEffect(() => {

        if (xJson) {

            if (json) {
                const newColumnVisibility: VisibilityState = { ...columnVisibility }
                newColumnVisibility.acao = json.acao
                newColumnVisibility.razao = json.razao
                newColumnVisibility.nome_fantasia = json.nome_fantasia
                newColumnVisibility.endereco = json.endereco
                newColumnVisibility.bairro = json.bairro
                newColumnVisibility.numero = json.numero
                newColumnVisibility.cep = json.cep
                newColumnVisibility.nome_cidade = json.nome_cidade
                newColumnVisibility.complemento = json.complemento
                newColumnVisibility.ie_rg = json.ie_rg
                newColumnVisibility.observacao = json.observacao
                newColumnVisibility.tipo_pessoa = json.tipo_pessoa
                newColumnVisibility.cnpj_cpf = json.cnpj_cpf
                newColumnVisibility.ativo = json.ativo
                newColumnVisibility.uf = json.uf
                newColumnVisibility.dt_cadastro = json.dt_cadastro
            }
        }

    }, [])
    */

    const [idTransp, setIdTransp] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [modalShow, setModalShow] = useState(false)
    const [feedBackVisible, setFeedBackVisible] = useState(false)
    const [messageFeedBack, setMessageFeedBack] = useState("")
    const [alertType, setAlertType] = useState<AlertType>("SUCCESS")
    const [columnVisibility, setColumnVisibility] = useState<VisibilityState>(defaultJson)

    const [transportadoras, setTransportadoras] = useState<Transportadora[]>([])
    const [nomeTransportadora, setNomeTransportadora] = useState("")

    let user = useSelector(state => selectUser(state))

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EFFECT -------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    useEffect(() => {
        setTransportadoras(transportadora)
    }, [transportadora])

    useEffect(() => {
        localStorage.setItem("@commerce/column_grid_transp", JSON.stringify(columnVisibility))
    }, [columnVisibility])


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- EXCLUIR e FOCUS ----------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const handleExcluir = useCallback(async (motivo: string, senha: string) => {

        setFeedBackVisible(false)
        setIsLoading(true)

        try {

            const retApi: RetAPI = await TransportadoraService.Delete(idTransp, motivo, senha)
            Inputfocus()

            if (!retApi.error) {
                setFeedBackVisible(true)
                setAlertType("SUCCESS")
                setMessageFeedBack(`Transportadora excluída com sucesso`)

                handleUpdateTransportadoraList()

                //setTransportadoras(await TransportadoraService.Filter('', '', ''))
                //setModalShow(false)

            } else {
                setFeedBackVisible(true)
                setAlertType("DANGER")
                setMessageFeedBack(retApi.msg || ``)
                setIsLoading(false)
                //setModalShow(false)
            }

        } catch (error) {
            setIsLoading(false)
            setFeedBackVisible(true)
            setAlertType("DANGER")
            setMessageFeedBack(`Não foi possível excluir a transportadora. Por favor, tente novamente`)
        }

    }, [idTransp])

    const Inputfocus = () => {
        const inputElement = document.getElementById("pesquisa_transportadora")
        inputElement?.focus()
    }

    const fecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)

        if (alertType == 'SUCCESS') {
            setModalShow(false)
            setNomeTransportadora("")
        }

    }, [alertType])

    const buttonFecharModalExcluirDados = useCallback(() => {
        setIsLoading(false)
        setFeedBackVisible(false)
        setModalShow(false)
        setNomeTransportadora("")
    }, [])

    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- TEMAS --------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const theme = createTheme({
        palette: {
            mode: user.modeDark,

            background: {
                default:
                    user.modeDark === 'light' ? '#fff' : '#475569',
            },
        },
    })

    const baseBackgroundColor = user.modeDark === 'dark' ? '#475569' : '#fff'


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- NAVEGAÇÃO ----------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const navigate = useNavigate()

    const navegarTelaTransportadoraEdit = (id: number) => {
        navigate(`/transportadora/edit/${id}`)
    }


    //---------------------------------------------------------------------------------------------------------------------------------
    // ----------------------------------------------------------- COLUNAS ------------------------------------------------------------
    //---------------------------------------------------------------------------------------------------------------------------------
    const tipoAtivoMap: TipoMap = {
        'S': 'Sim',
        'N': 'Não',
    }

    function mapTipoAtivo(ativo: string) {

        return (
            <>
                {tipoAtivoMap[ativo] || <div className='text-red-400'>N/D</div>}

            </>

        )
    }

    const tipoPessoaMap: TipoMap = {
        'F': 'Física',
        'J': 'Jurídica',
    }

    function mapTipoPessoa(tipoPessoa: string) {

        return (
            <>
                {tipoPessoaMap[tipoPessoa] || <div className='text-red-400'>N/D</div>}
            </>
        )
    }

    const colunas = useMemo<MRT_ColumnDef<Transportadora>[]>(() => [
        {
            accessorKey: 'acao', header: 'Ações', visibleInShowHideMenu: false, enableSorting: false, size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                const navegar = () => {
                    navegarTelaTransportadoraEdit(rowData.id)
                }

                const handleExcluirClick = () => {

                    const timerExcluir = setTimeout(() => {

                        setIdTransp(rowData.id)
                        setNomeTransportadora(rowData.razao)
                        setModalShow(true)
    
                        let divPerfil = document.getElementById('div-perfil') as HTMLDivElement
    
                        if (divPerfil) {
                            divPerfil.classList.add('hidden')
                        }
    
                        let menuFiltro = document.getElementById("divMenuFiltroTransp") as HTMLDivElement
                        let menuInputs = document.getElementById("divInputsTransp") as HTMLDivElement
    
                        if (menuFiltro) {
    
                            menuInputs.classList.add("invisible")
    
                            const timer = setTimeout(() => {
                                menuFiltro.classList.remove("max-h-[390px]")
                                menuFiltro.classList.add("max-h-[0px]")
                                Inputfocus()
                                clearTimeout(timer)
                            }, 100)
                        }

                        clearTimeout(timerExcluir)
                    }, 0);

                    
                    
                }

                return (
                    <div className={`flex justify-start w-full`}>
                        <button
                            onClick={navegar} data-tooltip-id={'tooltip-editar-' + rowData.id} id={'btn-editar-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-sky-600 w-[30px] h-[30px] rounded-md 
                                      bg-sky-500`}>
                            <RiEdit2Fill size="20px" />

                            <Tooltip style={{ backgroundColor: 'rgb(14, 165, 233)' }} id={'tooltip-editar-' + rowData.id} anchorSelect={'#btn-editar-' + rowData.id} positionStrategy="fixed" place='top-start'  >
                                <span className={`font-sans font-medium text-[13px]`}>Editar</span>
                            </Tooltip>
                        </button>

                        <button
                            onClick={handleExcluirClick} data-tooltip-id={'tooltip-excluir-' + rowData.id} id={'btn-excluir-' + rowData.id}
                            className={`flex items-center justify-center 
                                      text-white transition-all duration-300 
                                      hover:bg-red-600 w-[30px] h-[30px] rounded-md 
                                      bg-red-500 ml-2`} >
                            <FaTrashAlt size="18px" />

                            <Tooltip style={{ backgroundColor: 'rgb(239, 68, 68)' }} id={'tooltip-excluir-' + rowData.id} anchorSelect={'#btn-excluir-' + rowData.id} positionStrategy="fixed"  >
                                <span className={`font-sans font-medium text-[13px]`}>Excluir</span>
                            </Tooltip>
                        </button>
                    </div>
                )
            }
        },

        {
            accessorKey: 'razao', visibleInShowHideMenu: true, header: 'Razão / Nome', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.razao ? rowData.razao : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome_fantasia', visibleInShowHideMenu: true, header: 'Nome Fantasia', size: 300, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_fantasia ? rowData.nome_fantasia : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'endereco', visibleInShowHideMenu: true, header: 'Logradouro', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.endereco ? rowData.endereco : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'bairro', visibleInShowHideMenu: true, header: 'Bairro', size: 250, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.bairro ? rowData.bairro : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'numero', visibleInShowHideMenu: true, header: 'Número', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.numero ? rowData.numero : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'cep', visibleInShowHideMenu: true, header: 'Cep', size: 50, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cep ? Funcoes.FormatCep(rowData.cep.toString()) : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'nome_cidade', visibleInShowHideMenu: true, header: 'Cidade', size: 200, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.nome_cidade ? rowData.nome_cidade : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'complemento', visibleInShowHideMenu: true, header: 'Complemento', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.complemento ? rowData.complemento : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'ie_rg', visibleInShowHideMenu: true, header: 'Insc. Estadual / RG', size: 100, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.ie_rg ? rowData.ie_rg : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'observacao', visibleInShowHideMenu: true, header: 'Observação', size: 400, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.observacao ? rowData.observacao : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'tipo_pessoa', visibleInShowHideMenu: true, header: 'Tipo Pessoa', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData
                const tipoPessoa: string = rowData.tipo_pessoa

                return mapTipoPessoa(tipoPessoa)
            }
        },

        {
            accessorKey: 'cnpj_cpf', visibleInShowHideMenu: true, header: 'CPF / CNPJ', size: 150, muiTableBodyCellProps: { align: 'left' }, muiTableHeadCellProps: { align: 'left' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.cnpj_cpf ? Funcoes.FormatDoc(rowData.cnpj_cpf.toString()) : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'ativo', visibleInShowHideMenu: true, header: 'Ativo', size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {
                const rowData = cell.row.original as RowData
                const tipoAtivo: string = rowData.ativo

                return mapTipoAtivo(tipoAtivo)
            }
        },

        {
            accessorKey: 'uf', visibleInShowHideMenu: true, header: 'Estado', size: 50, muiTableBodyCellProps: { align: 'center' }, muiTableHeadCellProps: { align: 'center' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.uf ? rowData.uf : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

        {
            accessorKey: 'dt_cadastro', visibleInShowHideMenu: true, header: 'Data de Cadastro', size: 50, muiTableBodyCellProps: { align: 'right' }, muiTableHeadCellProps: { align: 'right' },

            Cell: (cell: any) => {

                const rowData = cell.row.original as RowData

                return (<span>{rowData.dt_cadastro ? moment(rowData.dt_cadastro).format('DD/MM/YYYY') : <span className='text-red-400'>N/D</span>}</span>)

            }
        },

    ], [])

    const table = useMaterialReactTable({
        columns: colunas,
        data: transportadoras,
        autoResetPageIndex: false,
        mrtTheme: (theme) => ({
            baseBackgroundColor: baseBackgroundColor,

        }),
        muiTableHeadCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`,
                backgroundColor: corBgGrid,
                color: `#fff`,
                '& .MuiTableSortLabel-root': {
                    color: '#fff !important',
                    '&:hover': {
                        color: '#fff !important',
                    },
                    '&.Mui-active': {
                        color: '#fff !important',
                    },
                    '& .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                    '&.Mui-active .MuiTableSortLabel-icon': {
                        color: '#fff !important',
                    },
                },
                '& .MuiIconButton-root': {
                    color: '#fff',
                    '&:hover': {
                        color: '#fff',
                    },
                },
            },
        },
        muiTableBodyCellProps: {
            sx: {
                borderBottom: `0.1px solid ${user.modeDark === 'light' ? bgLineGridColorLight : bgLineGridColorDark}`
            }
        },
        enableEditing: false,
        enableTopToolbar: true,
        enableColumnFilters: false,
        enableHiding: true,
        enableFilters: false,
        enableMultiSort: false,
        enableFullScreenToggle: false,
        enableDensityToggle: false,
        localization: MRT_Localization_PT_BR,
        paginationDisplayMode: 'pages',
        onColumnVisibilityChange: setColumnVisibility,
        state: { columnVisibility },
    })

    return (
        <>

            <ThemeProvider theme={theme}>

                <MaterialReactTable table={table} />

            </ThemeProvider>

            <ModalExcluirDados
                show={modalShow}
                isLoading={isLoading}
                message={`Deseja excluir a transportadora - ${nomeTransportadora || ''}?`}
                alertType={alertType}
                feedBackVisible={feedBackVisible}
                messageFeedBack={messageFeedBack}
                closeModalEvent={fecharModalExcluirDados}
                excluirEvent={handleExcluir}
                fecharModalEvent={buttonFecharModalExcluirDados}
            />

        </>

    )

})